export interface Tab_Constants_Type {
    JOB_DESCRIPTION_TAB: string;
    SEARCH_CRITERIA_TAB: string;
    EVALUATION_CRITERIA_TAB: string;
};

export interface Page_Constants_Type {
    LANDING_PAGE: string;
    PROJECT_LIST_PAGE: string;
    JOB_DESCRIPTION_PAGE: string;
    SEARCH_CRITERIA_PAGE: string;
    EVALUATION_CRITERIA_PAGE: string;
    PROJECT_DETAILS_PAGE: string;
    INSIGHTS_PAGE: string;
}

export class AiSourcingConstant {

    static readonly Tab_Constants: Tab_Constants_Type = {
        JOB_DESCRIPTION_TAB: 'job-description',
        SEARCH_CRITERIA_TAB: 'search-criteria',
        EVALUATION_CRITERIA_TAB: 'evaluation-criteria'
    };

    static readonly Page_Constants: Page_Constants_Type = {
        LANDING_PAGE: 'landing-page',
        PROJECT_LIST_PAGE: 'project-listing',
        JOB_DESCRIPTION_PAGE: 'job-description',
        SEARCH_CRITERIA_PAGE: 'search-criteria',
        EVALUATION_CRITERIA_PAGE: 'evaluation-criteria',
        PROJECT_DETAILS_PAGE: 'project-details',
        INSIGHTS_PAGE: 'insights-page'
    };

};